module.exports = __webpack_public_path__ + "static/MROPRO-f377e983d355d123502399a1dba0d7e8.png";